// extracted by mini-css-extract-plugin
export default {"skipBtn":"vArM74","wixLogo":"WFyAqT","root":"pg2doU"};